import { createRequestActionTypes } from "../../../shared/utility";

export const PspActions = {
    fetchPSPMetadata: createRequestActionTypes('FETCH_PSP_METADATA'),
    fetchPSPDetails: createRequestActionTypes('FETCH_PSP_DETAILS'),
    createPSP: createRequestActionTypes('CREATE_PSP'),
    //fetchStateNCity: createRequestActionTypes('FETCH_STATE_N_CITY')
}